import { render, staticRenderFns } from "./aside-menu.vue?vue&type=template&id=5dca0818&scoped=true&"
import script from "./aside-menu.vue?vue&type=script&lang=js&"
export * from "./aside-menu.vue?vue&type=script&lang=js&"
import style0 from "./aside-menu.vue?vue&type=style&index=0&id=5dca0818&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca0818",
  null
  
)

export default component.exports